import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialCardProps) {
  return <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl hover:border-yellow-500/50 transition-colors duration-300" data-id="element-38">
      <div className="flex gap-1 mb-4" data-id="element-39">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-40" />)}
      </div>

      <p className="text-gray-300 mb-6 text-sm leading-relaxed italic" data-id="element-41">
        "{content}"
      </p>

      <div className="flex items-center gap-3" data-id="element-42">
        {image ? <img src={image} alt={name} className="w-10 h-10 rounded-full object-cover border border-zinc-700" data-id="element-43" /> : <div className="w-10 h-10 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-yellow-500 font-bold" data-id="element-44">
            {name.charAt(0)}
          </div>}
        <div data-id="element-45">
          <h4 className="text-white font-bold text-sm" data-id="element-46">{name}</h4>
          <p className="text-zinc-500 text-xs" data-id="element-47">{role}</p>
        </div>
      </div>
    </div>;
}